import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router";
import { withLocalize } from 'react-localize-redux';
import { layoutActions } from '../../store/layoutStore';
import { userContextActions } from '../../store/userContextStore';

import { links, createPanelItem } from "./links";
import DockedMenu from './dockedMenu';
import DockedMenuInner from './dockedMenuInner';
import UserSettings from './userSettings';
import Notifications from './notifications';
import NavMenu from './navMenu';

import LogoCzWhite from "../../img/Cribis.cz_white";
import LogoSkWhite from "../../img/Cribis.sk_white";

class MobileDockerMenu extends Component {
    state = {  }
    render() {
        return (<>
            <DockedMenu isToggled={this.props.layout.isAccountMobileMenuToggled} hideDockedMenu={this.props.toggleAccountMobileMenu}>
                <DockedMenuInner title={this.props.translate('Common.User')} close={() => this.props.toggleAccountMobileMenu()}>
                    <div className='navbar-button-items'>
                        <UserSettings />
                    </div>
                </DockedMenuInner>
            </DockedMenu>
            <DockedMenu isToggled={this.props.layout.isNotificationsMobileMenuToggled} hideDockedMenu={this.props.toggleNotificationsMobileMenu}>
                <DockedMenuInner title={this.props.translate('NavBar.Notifications')} close={() => this.props.toggleNotificationsMobileMenu()}>
                    <Notifications />
                </DockedMenuInner>
            </DockedMenu>
            <DockedMenu isLeft={true} isToggled={this.props.layout.isBurgerMobileMenuToggled} hideDockedMenu={this.props.toggleBurgerMobileMenu}>
                <DockedMenuInner logo={this.getImage} close={() => this.props.toggleBurgerMobileMenu()}>
                    <NavMenu mobilMenu={true} />
                </DockedMenuInner>
            </DockedMenu>
            {links.slice(4).map(x => x.canShow()).length >= 1 && <DockedMenu isToggled={this.props.layout.areMoreLinksVisible} hideDockedMenu={this.props.toggleMoreItems}>
                <DockedMenuInner title="Menu" close={() => this.props.toggleMoreItems()}>
                    <div className="more-items-docked">
                        {links.slice(4).map(i => createPanelItem(i))}
                    </div>
                </DockedMenuInner>
            </DockedMenu>}
        </>);
    }

    getImage = () => {
        return (
            <div className='cribis-icon'>
                {this.props.user.authentication.profile.agentLanguage === 'sk-SK' && <LogoSkWhite className="svg-standard-fill" />}
                {this.props.user.authentication.profile.agentLanguage !== 'sk-SK' && <LogoCzWhite className="svg-standard-fill" />}
            </div>
        );
    }
}
export default withLocalize(connect(
    state => ({ layout: state.layout, user: state.userContext }),
    dispatch => bindActionCreators({ ...layoutActions, ...userContextActions }, dispatch)
)(withRouter(MobileDockerMenu)));